import { getEnv } from "@/utils";
import APIAbstract from "./apiAbstract";
import { AxiosResponse } from "axios";
import { Profile } from "vue";

export default class ProfileApi extends APIAbstract {
  constructor() {
    super({
      baseUrl: `${getEnv("oidcAuthAuthority", "notSet")}`,
      basePath: "profile",
    });
  }

  get endpoint(): string {
    return this.options.basePath;
  }

  public updateProfile(profile: Profile): Promise<AxiosResponse> {
    if (!profile || (!profile.firstName && !profile.lastName)) {
      return Promise.reject(new Error("Missing parameters"));
    }

    return this.client.post(`${this.endpoint}`, profile).then((response) => {
      return Promise.resolve(response);
    });
  }
}
